/**
 * @generated SignedSource<<8c6287fe23fb74a8f7895edaaa1e76ed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NoticeCreateInput = {
  description: string;
  title: string;
};
export type NoticeCreateDialog_noticeCreateMutation$variables = {
  input: NoticeCreateInput;
};
export type NoticeCreateDialog_noticeCreateMutation$data = {
  readonly noticeCreate: {
    readonly id: string;
  };
};
export type NoticeCreateDialog_noticeCreateMutation = {
  response: NoticeCreateDialog_noticeCreateMutation$data;
  variables: NoticeCreateDialog_noticeCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Notice",
    "kind": "LinkedField",
    "name": "noticeCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NoticeCreateDialog_noticeCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NoticeCreateDialog_noticeCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6e8772b1df9674d693bffd607ae55421",
    "id": null,
    "metadata": {},
    "name": "NoticeCreateDialog_noticeCreateMutation",
    "operationKind": "mutation",
    "text": "mutation NoticeCreateDialog_noticeCreateMutation(\n  $input: NoticeCreateInput!\n) {\n  noticeCreate(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "18889b781fff711556650009a9a89f3c";

export default node;
